import React from 'react';

import { getConfiguredStaticURL } from '../config/runtime.js';

export interface OperationTip {
  readonly title: React.ReactNode;
  readonly description: React.ReactNode;
}

export const servicePack1Tip: OperationTip = {
  title: (
    <>
      <span>系统版本问题</span>
      <span style={{ color: 'red', marginLeft: '10px' }}>Win7必要</span>
    </>
  ),
  description: (
    <div>
      Windows7系统请检查是否为 Service Pack 1 版本，若不是请先升级至
      <a
        rel="noreferrer"
        target="_blank"
        href="https://www.catalog.update.microsoft.com/Search.aspx?q=KB976932"
      >
        Service Pack 1{' '}
      </a>
      版本
    </div>
  ),
};

export function WebView2Downloads(): React.ReactElement {
  return (
    <div>
      <div>
        Windows 7 请使用 WebView2 109 离线安装包，在安装教师端或学生端前，以管理员身份运行：
      </div>
      <div>
        <a
          rel="noreferrer"
          target="_blank"
          href={getConfiguredStaticURL('/file/pclab2/MicrosoftEdgeWebView2RuntimeInstallerX86.exe')}
        >
          32 位系统（x86）下载
        </a>
        {' ｜ '}
        <a
          rel="noreferrer"
          target="_blank"
          href={getConfiguredStaticURL('/file/pclab2/MicrosoftEdgeWebView2RuntimeInstallerX64.exe')}
        >
          64 位系统（x64）下载
        </a>
      </div>
      <div>
        请在“计算机 → 属性 → 系统类型”查看系统位数。64 位系统请选择 x64 安装包，包含 x64 和 x86
        组件。客户端暂时统一使用 x86 版，运行时仍按操作系统位数安装。
      </div>
    </div>
  );
}

export const error101: OperationTip = {
  title: '程序运行后闪退（退出代码101）',
  description: (
    <div>
      若启动日志包含 CreateWebview、WebView2Error 和 0x80070002，请检查 WebView2
      是否安装完整，可按下方链接安装与操作系统匹配的运行时。退出代码 101 也可能由其他启动错误引起，请结合日志判断。
    </div>
  ),
};

export const webView2Tip: OperationTip = {
  title: (
    <>
      <span>Microsoft Edge WebView2</span>
      <span style={{ color: 'red', marginLeft: '10px' }}>Win7必要</span>
    </>
  ),
  description: (
    <div>
      <WebView2Downloads />
      <div style={{ marginTop: 12 }}>
        Windows 7安装Webview2遭遇到 0x800700b7错误的根本原因是“C:\Program
        Files\Microsoft\Edge“目录存在，且无写权限。
      </div>
      <div>解决方案为：CMD+R打开启动窗口，输入cmd，打开管理员权限命令行，输入如下指令：</div>
      <div style={{ marginLeft: 12 }}>
        takeown /f &quot;C:\Program Files\Microsoft\&quot; /r /d y
      </div>
      <div style={{ marginLeft: 12 }}>
        icacls &quot;C:\Program Files\Microsoft\&quot; /grant Administrators:F /t
      </div>
      <div style={{ marginLeft: 12 }}>rmdir /s /q &quot;C:\Program Files\Microsoft\Edge&quot;</div>
      <div>然后正常启动Webview2安装程序即可解决问题。</div>
    </div>
  ),
};

export const webView2Tip2: OperationTip = {
  title: (
    <>
      <span>WebView2安装遭遇 0x8024402c 或者 0x8004070c</span>
      <span style={{ color: 'red', marginLeft: '10px' }}>Win7必要</span>
    </>
  ),
  description: (
    <div>
      <div>1. 获取 C:\Program Files(x86)\Microsoft 管理员权限</div>
      <div>2. 删除 C:\Program Files(x86)\Microsoft</div>
      <div>3. 右键管理员安装WebView2</div>
    </div>
  ),
};

export const advapiTip: OperationTip = {
  title: (
    <>
      <span>advapi</span>
      <span style={{ color: 'red', marginLeft: '10px' }}>Win7必要</span>
    </>
  ),
  description: (
    <div>
      <div>
        若您安装时出现
        “无法定位程序输入点EventSetInformation于动态链接库advapi32.dll上”，请安装advapi插件
      </div>
      <div>
        64位：
        <a
          rel="noreferrer"
          target="_blank"
          href="https://www.microsoft.com/en-us/download/details.aspx?id=48636"
        >
          点击下载
        </a>
      </div>
      <div>
        32位：
        <a
          rel="noreferrer"
          target="_blank"
          href="https://www.microsoft.com/en-us/download/details.aspx?id=48638"
        >
          点击下载
        </a>
      </div>
    </div>
  ),
};

export const win7CrtTip: OperationTip = {
  title: (
    <>
      <span>Universal C Runtime 更新</span>
      <span style={{ color: 'red', marginLeft: '10px' }}>Win7必要</span>
    </>
  ),
  description: (
    <div>
      <div>
        若您启动程序时出现 “无法启动此程序，因为计算机中丢失
        api-ms-win-crt-math-l1-1-0.dll。尝试重新安装该程序以解决此问题”，请安装Universal C Runtime
        更新
      </div>
      <div>
        64位：
        <a
          rel="noreferrer"
          target="_blank"
          href="https://download.microsoft.com/download/1/1/5/11565A9A-EA09-4F0A-A57E-520D5D138140/Windows6.1-KB2999226-x64.msu"
        >
          点击下载
        </a>
      </div>
      <div>
        32位：
        <a
          rel="noreferrer"
          target="_blank"
          href="https://download.microsoft.com/download/4/F/E/4FE73868-5EDD-4B47-8B33-CE1BB7B2B16A/Windows6.1-KB2999226-x86.msu"
        >
          点击下载
        </a>
      </div>
    </div>
  ),
};

export const closeAntivirusTip: OperationTip = {
  title: '关闭病毒查杀',
  description: (
    <div>
      <div style={{ fontWeight: 600, color: 'red', marginBottom: '10px' }}>
        请务必关闭杀毒软件和360安全卫士或将本应用安装目录加入白名单
      </div>
      <video src={getConfiguredStaticURL('/file/pclab2/videos/wd.mp4')} controls width="100%" />
    </div>
  ),
};

export const visualCppTip: OperationTip = {
  title: (
    <>
      <span>Visual C++ Redistributable for Visual Studio 2015</span>
      <span style={{ color: 'red', marginLeft: '10px' }}>Win7必要</span>
    </>
  ),
  description: (
    <div>
      <div>
        若您安装时出现 “无法启动此程序，因为计算机中丢失
        VCRUNTIME140.dll。尝试重新安装该程序以解决此问题。”，请安装Visual C++ Redistributable for
        Visual Studio 2015
      </div>
      <div>
        32位：
        <a
          rel="noreferrer"
          target="_blank"
          href="https://download.microsoft.com/download/9/3/F/93FCF1E7-E6A4-478B-96E7-D4B285925B00/vc_redist.x86.exe"
        >
          点击下载
        </a>
      </div>
    </div>
  ),
};

export const win7Certs: OperationTip = {
  title: (
    <>
      <span>Windows 7根证书和CA证书更新</span>
      <span style={{ color: 'red', marginLeft: '10px' }}>Win7必要</span>
    </>
  ),
  description: (
    <div>
      <div>
        若您运行教师端时连接互联网就出现SSL证书已经失效故障，请下载并使用管理员权限运行解压后的install.bat
      </div>
      <div>
        <a
          rel="noreferrer"
          target="_blank"
          href={getConfiguredStaticURL('/file/pclab2/win7certs.zip')}
        >
          点击下载
        </a>
      </div>
    </div>
  ),
};

export const winUpdateServer: OperationTip = {
  title: 'Windows Update 独立安装程序 错误0x80070422',
  description: (
    <div>
      <div>
        安装程序遇到错误:0x80070422 无法启动服务，原因可能是已被禁用或与其相关联的设备没有启动
      </div>
      <div>
        解决办法：1. 按下Win+R组合键打开“运行”对话框。2.
        输入“services.msc”并按回车，打开服务面板。3. 在列表中找到 Windows Update
        服务，双击进入属性。4. 如果服务状态为停止，请点击“启动”按钮。确保启动类型设置为“自动”。
      </div>
    </div>
  ),
};

export const win7UpdateServer: OperationTip = {
  title: (
    <>
      <span>Windows7 Update 错误0x80240038，0x80070057</span>
      <span style={{ color: 'red', marginLeft: '10px' }}>Win7必要</span>
    </>
  ),
  description: (
    <div>
      <div>1.检查计算机时间是否正确</div>
      <div>2.以管理员身份运行命令行工具，开始，运行，输入cmd</div>
      <div>3.输入如下指令重置Windows Update组件</div>
      <div style={{ marginLeft: 12 }}>net stop wuauserv</div>
      <div style={{ marginLeft: 12 }}>net stop bits</div>
      <div style={{ marginLeft: 12 }}>net stop cryptsvc</div>
      <div style={{ marginLeft: 12 }}>ren %systemroot%\System32\Catroot2 oldcatroot2</div>
      <div style={{ marginLeft: 12 }}>net start cryptsvc</div>
      <div style={{ marginLeft: 12 }}>
        nen %systemroot%\SoftwareDistribution SoftwareDistribution.old
      </div>
      <div style={{ marginLeft: 12 }}>net start bits</div>
      <div style={{ marginLeft: 12 }}>net start wuauserv</div>
      <div>4.安装完补丁重启才能生效</div>
    </div>
  ),
};

export const chromeBrowserUpdate: OperationTip = {
  title: 'Chrome浏览器更新',
  description: (
    <div>
      <div>若无法打开管理平台，请更新Chrome浏览器</div>
      <a href="https://www.google.cn/chrome/">Chrome浏览器官网</a>
    </div>
  ),
};

export const windowsFirewall: OperationTip = {
  title: 'Windows防火墙',
  description: (
    <div>
      <div>按照如下两种方式任意一种配置Windows防火墙：</div>
      <div>1.关闭教师机和学生机上的Windows防火墙，注意标注了（使用中）中的那个也需要关闭；</div>
      <div>
        2.在教师机上配置教师端程序、教师机服务器程序（pclab-teacher-server.exe）和在学生机上配置学生端程序都可以通过Windows防火墙。
      </div>
    </div>
  ),
};

export const win10Error0xc000007b: OperationTip = {
  title: 'Win10 应用程序无法正常启动 (0xc000007b)',
  description: (
    <div>
      <div>
        若您在 Win10 系统中运行应用程序时出现 &quot;应用程序无法正常启动 (0xc000007b)&quot;
        错误，请安装 Microsoft Visual C++ 2015-2022 Redistributable (x86) 运行库
      </div>
      <div>
        下载地址：
        <a rel="noreferrer" target="_blank" href="https://aka.ms/vc14/vc_redist.x86.exe">
          点击下载
        </a>
      </div>
      <div style={{ marginTop: '8px' }}>
        注意：即使系统是 64 位，也需要安装 x86 版本的运行库。如果问题仍未解决，建议同时安装 x64
        版本。
      </div>
    </div>
  ),
};

